<script>
import axios from '@/utils/axios';
import { clientAdmin } from "@/utils/auth";

export default {
  inject: ['setLoading'],
  data() {
    return {
      title: "HRM",
      text: "Asset",
      text1: "Categories",
      clientAdmin: clientAdmin(),
      data: [],
      selectedCategory: null,
    };
  },

  mounted() {
    this.fetchCategories();
  },

  methods: {

    async fetchCategories() {
      this.setLoading(true);
      try {
        const response = await axios.get('/hrms/assets/categories');
        this.data = response.data.data || [];
      } catch (error) {
        this.data = [];
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },

    openCreateModal() {
      this.selectedCategory = null;
      this.$nextTick(() => this.$openModal('hrm_asset_category_modal'));
    },

    openEditModal(category) {
      this.selectedCategory = category;
      this.$nextTick(() => this.$openModal('hrm_asset_category_modal'));
    },

    async deleteCategory(category) {
      const result = await this.$confirm({ text: `Delete category "${category.name}"? This cannot be undone.` });
      if (!result.isConfirmed) return;
      this.setLoading(true);
      try {
        await axios.delete(`/hrms/assets/categories/${category.id}`);
        this.$swalToast('Category deleted successfully.');
        this.fetchCategories();
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },
  }
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">

      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <router-link to="/hrms/assets" class="btn btn-outline-secondary d-flex align-items-center me-2">
            <i class="ti ti-arrow-back-up me-2"></i>Back to Assets
          </router-link>
          <button class="btn btn-primary d-flex align-items-center" @click="openCreateModal">
            <i class="ti ti-plus me-2"></i>Add Category
          </button>
        </div>
      </div>

      <!-- Table -->
      <div class="row">
        <div class="col-lg-12">
          <div class="card-body card-table-wrapper">
            <div class="custom-datatable-filter table-responsive">
              <table class="card-table" v-if="data && data.length">
                <thead>
                    <tr>
                    <th>#</th>
                    <th>Category</th>
                    <th>Description</th>
                    <th>Assets Count</th>
                    <th>Status</th>
                    <th class="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in data" :key="row.id || index">
                        <td>{{ index + 1 }}.</td>
                        <td><strong class="text-dark">{{ row.name }}</strong></td>
                        <td>{{ row.description || '-' }}</td>
                        <td>{{ row.assets_count ?? 0 }}</td>
                        <td>
                          <span class="badge rounded-pill" :class="row.is_active ? 'bg-success' : 'bg-secondary'">
                            {{ row.is_active ? 'Active' : 'Inactive' }}
                          </span>
                        </td>
                        <td class="text-end">
                          <button class="btn btn-sm btn-outline-secondary me-1" @click="openEditModal(row)">
                            <i class="ti ti-edit"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-danger" :disabled="row.assets_count > 0"
                            :title="row.assets_count > 0 ? 'Cannot delete: category has assets' : ''"
                            @click="deleteCategory(row)">
                            <i class="ti ti-trash"></i>
                          </button>
                        </td>
                        </tr>
                </tbody>
              </table>
              <div v-else class="p-3 text-center text-muted">No categories found.</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <app-footer></app-footer>
  </div>

  <hrm-asset-category-modal :category="selectedCategory" @saved="fetchCategories" />
</template>